import { Component, OnInit, Input } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalService } from 'src/app/services/global.service';
import { NewfolderService } from 'src/app/services/newfolder.service';

@Component({
  selector: 'app-change-name-folder',
  templateUrl: './change-name-folder.component.html',
  styleUrls: ['./change-name-folder.component.css']
})
export class ChangeNameFolderComponent implements OnInit {

  //boolean
  check: boolean
  newGroup = false;
  changeFolderName = false;
  changed = false;
  other = true;
  permits: boolean = false;


  //array
  group: Array<any> = [];
  groupAdd: Array<any> = [];
  customer: Array<any> = [];
  customerF: Array<any> = [];
  customerG: Array<any> = [];
  groupAddC: Array<any> = [];
  groupAddModify: Array<any> = [];
  groupAddGrp: Array<any> = [];

  //string
  token: string;
  nameGroup: string = '';
  changeNameFolder: string;
  folder: string = 'Cartella senza nome';

  constructor(
    private modalService: NgbModal,
    private globals: GlobalService,
    public activeModal: NgbActiveModal,
    public newfolderService: NewfolderService,
  ) { }


  //Input
  @Input() folderName;
  @Input() id;

  ngOnInit() {
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.getCustomer();
    this.getGroups();
    this.setList();
  }

  getCustomer() {
    this.newfolderService.getCustomer(this.token).subscribe(
      res => {
        this.customer = res;
        this.customer.forEach((element, k) => {
          if (element.type == "F") {
            this.customerF.push(this.customer[k])
          } else {
            this.customerG.push(this.customer[k])
          }
        });
      },
      err => {
        console.error("Errore in getOperators", err);

      }
    )
  }

  getGroups() {
    this.newfolderService.getGroups(this.token).subscribe(
      res => {
        this.group = res;
        this.group.forEach(grp => {
          grp.select = false;
        })
      },
      err => {
        console.error("Errori in getGroups: ", err);
      }
    )
  }

  setList() {
    if (this.id) {
      this.changeFolderName = true;
      this.changed = true;
      this.newfolderService.getPermission(this.token, this.id).subscribe(
        res => {
          if (res.locallySet) {
            if (res.locallySet.length > 0) {
              this.groupAdd = res.locallySet;
              this.groupAdd.forEach(element => {
                if (element.group_name) {
                  this.groupAddGrp.push(element);
                } else {
                  this.groupAddC.push(element);
                }
              })
            }
          }
        },
        err => {
          console.error("Errore in getPermission: ", err);
        }
      )
      this.groupAdd.forEach(element => {
        if (element.group_name) {
          this.groupAddGrp.push(element);
        } else {
          this.groupAddC.push(element)
        }
      })
    }
  }

  delFolder() {
    this.newfolderService.delFolder(this.token, this.id).subscribe(
      res => {
        this.activeModal.close();
      },
      err => {
        console.error("Errore in deleteFolder: ", err);
      }
    )
  }

  add() {
    this.newGroup = true;
  }

  push(add) {

    let control: boolean = false

    if (add) {

      if (add.customer_id) {
        this.groupAddC.forEach(cus => {
          if (cus.customer_id == add.customer_id) {
            control = true;
          }
        });
      }

      if (add.group_id) {
        this.groupAddGrp.forEach(grp => {
          if (grp.group_id == add.group_id) {
            control = true;
          }
        });
      }

      if (control == false) {
        this.groupAdd.push(add)
        if (add.group_name) {
          this.groupAddGrp.push(add);
        } else {
          this.groupAddC.push(add);
        }
      } else {
        alert("il profilo selezionato è già stato inserito nella lista")
      }
    } else {
      alert("Seleziona un profilo")
    }
  }

  delete(list) {


    this.groupAdd.splice(this.groupAdd.indexOf(list), 1);

    if (list.group_name) {
      this.groupAddGrp.splice(this.groupAddGrp.indexOf(list), 1);
    } else {
      this.groupAddC.splice(this.groupAddC.indexOf(list), 1);
    }
  }

  updateFolder() {
    if (this.changed == true) {
      this.newfolderService.updateNameFolder(this.token, this.id, { name: this.folderName }).subscribe(
        res => {
          if (this.groupAdd.length > 0) {
            let obj: any;
            obj = {
              auth: [],
              inherited: false
            }

            this.groupAdd.forEach(id => {
              if (id.authorityId) {
                obj.auth.push({
                  authorityId: id.authorityId,
                  name: "Contributor",
                  accessStatus: "ALLOWED",
                })
              } else {
                obj.auth.push({
                  authorityId: id.alfresco_id,
                  name: "Contributor",
                  accessStatus: "ALLOWED",
                })
              }
            });
            let id: string = res.folder_id
            this.newfolderService.setPermission(this.token, obj, id).subscribe(
              res => {
              },
              err => {
                console.error("Errore in setPermission: ", err);
              }
            )
          }
          this.activeModal.close();
        },
        err => {
          console.error("Errore in addFolder: ", err);
        }
      )
    }
  }

  addGroup() {
    if (this.nameGroup) {
      let obj = {
        group: {
          group_name: this.nameGroup
        },
        customers: []
      }
      this.newfolderService.newGroup(this.token, obj).subscribe(
        res => {
          this.getGroups();
          this.newGroup = false;
          this.nameGroup = ''
        }, err => {
          console.error("Errore in addGroup: ", err);
        }
      )
    } else {
      alert("Inserisci il nome del gruppo")
    }
  }

  smista() {
    this.groupAdd.forEach(element => {
      if (element.group_name) {
        this.groupAddGrp.push(element);
      } else {
        this.groupAddC.push(element)
      }
    });
  }

  permitsFunc() {
    if (this.permits) {
      this.permits = false;
    } else {
      this.permits = true;
    }

  }

  canceling() {
    this.activeModal.close('Cancel');
  }

}
